import {useLazyQuery} from '@apollo/client'
import {useNavigate, useParams} from 'react-router-dom'
import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {Button, ButtonGroup, Card, Spinner, Table} from 'react-bootstrap'
// import moment from 'moment'
import {ModalAddDeduction} from './ModalAddDeduction'
import {GET_ALL_USER_DEDUCTIONS} from '../../../gql/queries/usersQuery'
import {IResAllUserDeductionNodeEdges, IUserDeductionNode} from '../../../types/users'
import {useDisclourse} from '../../../hooks/useDisclourse'
import {formatDeductionValue} from '../../../helpers'
import moment from 'moment'
import {ModalDeleteDeduction} from './ModalDeleteDeduction'

export const DeductionsTab = () => {
  const [gqlGetUserDeductions, {data, loading, error, refetch}] =
    useLazyQuery<IResAllUserDeductionNodeEdges>(GET_ALL_USER_DEDUCTIONS, {
      fetchPolicy: 'no-cache',
    })

  const navigate = useNavigate()
  const {id} = useParams()

  const [info, setInfo] = useState<IUserDeductionNode | null>(null)

  const {isOpen: isOpenAdd, onClose: onCloseAdd, onOpen: onOpenAdd} = useDisclourse()
  const {isOpen: isOpenDelete, onClose: onCloseDelete, onOpen: onOpenDelete} = useDisclourse()
  const {isOpen: isOpenEdit, onClose: onCloseEdit, onOpen: onOpenEdit} = useDisclourse()

  useEffect(() => {
    if (!id) {
      return navigate('/')
    }
    if (Number(id)) {
      gqlGetUserDeductions({
        variables: {
          user_Id: id,
        },
      })
      return
    }
    navigate('/')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
  }, [error])

  const allDeductions = data?.allCommissionDeductionUser

  return (
    <>
      <Card>
        <Card.Header className='align-items-center'>
          <Card.Title>
            <h3 className=''>Deductions</h3>
          </Card.Title>
          <div>
            <Button
              variant='primary'
              size='sm'
              onClick={() => {
                onOpenAdd()
              }}
            >
              <i className='bi bi-plus' />
              Add Deduction
            </Button>
          </div>
        </Card.Header>
        {loading && (
          <Card.Body>
            <div className='d-flex flex-center' style={{height: '30vh'}}>
              <Spinner animation='border' />
            </div>
          </Card.Body>
        )}
        {!allDeductions && !loading && (
          <Card.Body>
            <div className='d-flex flex-center' style={{height: '30vh'}}>
              <h6>This user does not have wallet or transactions</h6>
            </div>
          </Card.Body>
        )}
        {allDeductions && !loading && (
          <Card.Body>
            <div className='mt-5'>
              {!data || loading ? (
                <div className='d-flex flex-center' style={{height: '35vh'}}>
                  <Spinner animation='border' />
                </div>
              ) : (
                <div>
                  <Table>
                    <thead className='bg-secondary'>
                      <tr>
                        <th className='px-4'>Value</th>
                        <th className='px-4'>Type</th>
                        <th className='px-4'>Created</th>
                        <th className='px-4'>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allDeductions?.edges.map(({node}) => (
                        <tr key={node.id}>
                          <td className='px-4'>
                            {formatDeductionValue(node.value, node.deductionType?.deductionType as 'PERCENTAGE' | 'FIXED')}
                          </td>
                          <td className='px-4'>{node?.deductionType?.name ?? ''}</td>
                          <td className='px-4'>
                            {moment(node.created).format('MMM DD, YYYY [at] hh:mm A')}
                          </td>
                          <td className='text-center'>
                            <ButtonGroup className='btn-sm'>
                              <Button
                                size='sm'
                                variant='secondary'
                                className='btn-sm btn-edit'
                                onClick={() => {
                                  setInfo(node)
                                  onOpenEdit()
                                }}
                              >
                                <i className='bi bi-pencil fs-4' />
                              </Button>
                              <Button
                                size='sm'
                                variant='danger'
                                className='btn-sm btn-delete'
                                onClick={() => {
                                  setInfo(node)
                                  onOpenDelete()
                                }}
                              >
                                <i className='bi bi-trash  fs-4'></i>
                              </Button>
                            </ButtonGroup>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}
            </div>
          </Card.Body>
        )}
      </Card>
      {isOpenEdit && info && (
        <ModalAddDeduction
          keyboard={false}
          backdrop='static'
          userDeduction={info}
          userId={id ?? ''}
          isOpen={isOpenEdit}
          onClose={onCloseEdit}
          isEdit={true}
          refetch={refetch}
        />
      )}
      {isOpenDelete && info && (
        <ModalDeleteDeduction
          infoEdit={info}
          isOpen={isOpenDelete}
          onClose={onCloseDelete}
          refetch={refetch}
        />
      )}
      {isOpenAdd && (
        <ModalAddDeduction
          keyboard={false}
          backdrop='static'
          userId={id ?? ''}
          isOpen={isOpenAdd}
          isEdit={false}
          onClose={onCloseAdd}
          refetch={refetch}
        />
      )}
    </>
  )
}
